import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Drawer,
  Avatar,
  Progress,
  Skeleton,
  List,
  Popover,
  Divider,
} from "antd";
import { API } from "aws-amplify";
import Moment from "moment";
import Masonry from "@mui/lab/Masonry";
import {
  CloseSquareFilled,
  FolderOpenOutlined,
  FilterOutlined,
  UnorderedListOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import MainHeader from "../../../../common/MainHeader";
import ScriptCard from "../../../../common/ScriptCard";

export default function StatInfo(props) {
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [scriptItem, setscriptItem] = useState({});
  const [scriptIcon, setscriptIcon] = useState(null);
  const [questionList, setquestionList] = useState([]);
  const [isLoadingQuestions, setLoadingQuestions] = useState(false);
  // const [filterList, setfilterList] = useState([]);
  // const [scriptUpdateTime, setScriptUpdateTime] = useState(null);
  const [profileNames, setProfileNames] = useState(null);
  const [showAllScripts, setShowAllScripts] = useState(false);
  const [screenResolutionWidth, setScreenResolutionWidth] = useState(0);
  const [filteredOption, setfilteredOption] = useState("All");

  useEffect(() => {
    const box = document.getElementById("statInfoParent");
    setScreenResolutionWidth(box.offsetWidth);
  });

  useEffect(() => {
    const {
      criticalInfoScriptId,
      criticalInfoScriptIcon,
      profileId,
      orgId,
      profileUserNames,
      isMobile,
    } = props;

    if (criticalInfoScriptId && profileId && orgId) {
      getScriptQuestions(criticalInfoScriptId, profileId, orgId);
    }

    if (criticalInfoScriptIcon) {
      setscriptIcon(criticalInfoScriptIcon);
    } else {
      setscriptIcon(null);
    }

    if (profileUserNames) {
      setProfileNames(profileUserNames);
    }

    if (isMobile) {
      setIsMobileDevice(isMobile);
    }
  }, [props]);

  const getScriptQuestions = async (scriptId, profileId, orgId) => {
    setLoadingQuestions(true);
    await API.get(
      "list",
      `/mobile/list/scriptQuestions/${scriptId}/${profileId}/${orgId}`,
      {}
    )
      .then(async (response) => {
        setscriptItem(response);
        await settingScriptQuestionsList(response);
      })
      .catch((error) => {
        setLoadingQuestions(false);
      });
  };

  const settingScriptQuestionsList = async (response) => {
    if (response.questions) {
      const arr = [];
      for (const key in response.questions) {
        if (response.questions[key] && response.questions[key].length > 0) {
          let scriptUpdateTime = null;
          for (const item of response.questions[key]) {
            item.questionDetails.updated = Moment(
              item.questionDetails.updatedAt
            ).format("MM/DD/YYYY");
            if (
              (scriptUpdateTime &&
                item.questionDetails.updated > scriptUpdateTime) ||
              !scriptUpdateTime
            ) {
              scriptUpdateTime = item.questionDetails.updated;
            }
            // setScriptUpdateTime(scriptUpdateTime);
          }
        }
        arr.push({
          cat: key,
          questionList: response.questions[key],
          collapse: true,
        });
      }
      setquestionList(arr);
      // setfilterList(JSON.parse(JSON.stringify(arr)));
      setLoadingQuestions(false);
    } else {
      setLoadingQuestions(false);
    }
  };

  const ShowQuestions = (cardWidth) => {
    return (
      <Masonry
        columns={cardWidth === null || isMobileDevice ? 1 : 3}
        spacing={isMobileDevice ? 1 : 2}
      >
        {questionList[0]?.questionList
          ?.slice(0, showAllScripts ? questionList[0]?.questionList.length : 9)
          .map((question, j) => (
            <div key={j}>
              {filteredOption === "Answered" ? (
                question.questionDetails.answered === true && (
                  <ScriptCard
                    questionInfo={question}
                    profileNames={profileNames}
                    cardWidth={cardWidth}
                  />
                )
              ) : filteredOption === "NotAnswered" ? (
                (!question.questionDetails.answered ||
                  question.questionDetails.answered === false) && (
                  <ScriptCard
                    questionInfo={question}
                    profileNames={profileNames}
                    cardWidth={cardWidth}
                  />
                )
              ) : (
                <ScriptCard
                  questionInfo={question}
                  profileNames={profileNames}
                  cardWidth={cardWidth}
                />
              )}
            </div>
          ))}
      </Masonry>
    );
  };

  const content = (
    <div>
      <p
        onClick={() => setfilteredOption("All")}
        style={{
          fontSize: "17px",
          marginLeft: "5px",
          color: "#000",
          cursor: "pointer",
        }}
      >
        <UnorderedListOutlined /> All Questions
      </p>
      <p
        onClick={() => setfilteredOption("Answered")}
        style={{
          fontSize: "17px",
          marginLeft: "5px",
          color: "#000",
          cursor: "pointer",
        }}
      >
        <CheckOutlined style={{ color: "#6a347d" }} /> Answered
      </p>
      <p
        onClick={() => setfilteredOption("NotAnswered")}
        style={{
          fontSize: "17px",
          marginLeft: "5px",
          color: "#000",
          cursor: "pointer",
        }}
      >
        <CloseOutlined style={{ color: "tomato" }} /> Not Answered
      </p>
    </div>
  );

  const ScriptOptions = () => {
    return (
      <Row justify={"space-between"}>
        <Col>
          <Row>
            <Col>
              {scriptIcon ? (
                <Avatar size={48} src={scriptIcon} />
              ) : (
                <Avatar size={48} style={{ background: scriptItem?.color }}>
                  <span
                    style={{
                      fontSize: "28px",
                      color: "#FFF",
                      textTransform: "uppercase",
                    }}
                  >
                    {scriptItem?.scriptName
                      ? `${scriptItem?.scriptName?.charAt(0)}`
                      : "C"}
                  </span>
                </Avatar>
              )}
            </Col>
            <Col>
              <div style={{ margin: "5px" }}>
                <MainHeader
                  title={
                    scriptItem?.scriptName
                      ? `${scriptItem?.scriptName} ( ${questionList[0]?.questionList.length} )`
                      : null
                  }
                />
                <Progress
                  strokeLinecap="round"
                  strokeColor={scriptItem?.color}
                  percent={parseInt(scriptItem?.scriptPercentage)}
                />
              </div>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row>
            <Col>
              <div style={{ margin: "5px" }}>
                <Popover content={content} trigger="hover">
                  <span
                    style={{
                      fontSize: "18px",
                      textAlign: "center",
                      marginBottom: "-10px",
                      cursor: "pointer",
                      color: "#6a347d",
                      textDecoration: "underline",
                    }}
                  >
                    <FilterOutlined />
                  </span>
                </Popover>
              </div>
            </Col>
            <Col>
              <Divider
                type="vertical"
                style={{
                  fontSize: "22px",
                  textAlign: "center",
                  marginBottom: "-10px",
                }}
              />
            </Col>
            {showAllScripts ? (
              <Col>
                <span
                  style={{
                    fontSize: "18px",
                    textAlign: "center",
                    cursor: "pointer",
                    color: "tomato",
                  }}
                >
                  <p style={{ marginTop: "5px" }}>
                    Close{" "}
                    <CloseSquareFilled
                      onClick={() => setShowAllScripts(false)}
                    />
                  </p>
                </span>
              </Col>
            ) : (
              <Col>
                <div style={{ margin: "5px" }}>
                  {questionList[0]?.questionList.length > 9 && (
                    <span
                      style={{
                        fontSize: "18px",
                        textAlign: "center",
                        marginBottom: "-5px",
                        cursor: "pointer",
                        color: "#6a347d",
                      }}
                      onClick={() => setShowAllScripts(true)}
                    >
                      View All
                    </span>
                  )}
                </div>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <div>
      {questionList[0]?.questionList.length > 0 ? (
        <div
          style={{ background: "#FFF", borderRadius: "10px", padding: "28px" }}
        >
          <ScriptOptions />

          <div style={{ marginTop: "10px", marginRight: "-16px" }}>
            {ShowQuestions(screenResolutionWidth)}
          </div>

          <Drawer
            title={null}
            placement="right"
            onClose={() => setShowAllScripts(false)}
            open={showAllScripts}
            width={isMobileDevice ? "100%" : "75%"}
          >
            <ScriptOptions />

            <div
              style={{
                marginTop: "10px",
                background: "#f5f5f5",
                padding: "20px",
                borderRadius: "10px",
              }}
            >
              {ShowQuestions(null)}
            </div>
          </Drawer>
        </div>
      ) : (
        <div
          style={{
            background: "#FFF",
            borderRadius: "10px",
            padding: "28px",
            minHeight: "345px",
          }}
        >
          {isLoadingQuestions ? (
            <Row gutter={[16, 16]}>
              {Array.from({
                length: isMobileDevice ? 3 : 9,
              }).map((index) => (
                <Col
                  xxl={{ span: 8 }}
                  xl={{ span: 8 }}
                  lg={{ span: 8 }}
                  md={{ span: 24 }}
                  sm={{ span: 24 }}
                  xs={{ span: 24 }}
                  key={index}
                >
                  <Skeleton loading={isLoadingQuestions} active>
                    <List.Item.Meta title={" "} description={" "} />{" "}
                  </Skeleton>
                </Col>
              ))}
            </Row>
          ) : (
            <Row justify={"center"}>
              <Col
                style={{
                  padding: "30px",
                  textAlign: "center",
                  marginTop: "50px",
                }}
              >
                <FolderOpenOutlined
                  style={{ fontSize: "100px", color: "#ccc" }}
                />
                <h3 style={{ textAlign: "center", color: "#ccc" }}>
                  Script Questions Not Found
                </h3>
              </Col>
            </Row>
          )}
        </div>
      )}
    </div>
  );
}
